// extracted by mini-css-extract-plugin
export default {"vault":"VaultsItem_vault__fDKSl","content":"VaultsItem_content__QyLy1"};